import { createFileRoute } from '@tanstack/react-router'
import UserSettings from '../pages/(Admin)/UserSettings/UserSettings'
import AppLayout from '../layouts/AppLayout'

export const Route = createFileRoute('/user-settings')({
  component: UserSettingsComponent,
})

function UserSettingsComponent() {
  return (
    <AppLayout>
      <UserSettings />
    </AppLayout>
  )
}
